import { api } from '../utils/api';
import API_ENDPOINTS from '../config/apiConfig';

/**
 * Get forecast detail data from the vw_ForecastDetail view
 * @param {Object} params - Query parameters
 * @param {number} params.orgId - Organization ID
 * @param {number} params.locationId - Location ID
 * @param {number} params.chartOfAccountId - Chart of Account ID
 * @param {number} params.year - Year to filter by
 * @returns {Promise<Array>} Array of forecast detail records
 */
export const getForecastDetail = async ({ orgId, locationId, chartOfAccountId, year }) => {
  try {
    const params = {};
    if (orgId) params.orgId = orgId;
    if (locationId) params.locationId = locationId;
    if (chartOfAccountId) params.chartOfAccountId = chartOfAccountId;
    if (year) params.year = year;

    const response = await api.get(API_ENDPOINTS.FORECAST_DETAIL, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching forecast detail:', error);
    console.error('Error response:', error.response);
    console.error('Error config:', error.config);
    throw error;
  }
};
